import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import { MdOutlineClose, MdOutlineFileUpload } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import closeIcon from "../../images/close_icon.png";
import downloadDocImg from "../../images/download_doc_img.png";
import userIcon from "../../images/user_icon.png";
import { deleteDocumentsApi, getAttachmentsApi } from '../../Redux/Action/InterestedTender';
import { fileBaseUrl, getSource, getUserDetail } from '../../Utils/Helper';
import Loader from '../../Utils/Loader';
import { successNotify } from '../../Utils/Toast';

const AddAttachment = ({ uploadModal, setUploadModal, loading, onSubmit, documentLoading,
    onDocumentSubmit, stagedFiles, setStagedFiles, comment, setComment }) => {
    const dispatch = useDispatch();

    const [cancelPopup, setCancelPopup] = useState(false);

    const { loading: getAttachmentLoading, getAttachmentData } = useSelector((state) => state.getAttachments);
    const { loading: getDocumentDeleteLoading, getDocumentDeleteData, error } = useSelector((state) => state.getDeletedDocument);

    useEffect(() => {
        if (getDocumentDeleteData?.statusCode === 200) {
            successNotify("Document Deleted Successfully!");
            dispatch({ type: "DELETE_DOCUMENT_RESET" });

            const data = {
                tender_id: uploadModal?.tenderId,
                source_type: getSource(uploadModal?.type)
            }

            dispatch(getAttachmentsApi(data));
        }
        else if (error) {
            successNotify(error);
            dispatch({ type: "DELETE_DOCUMENT_RESET" });
        }
    }, [getDocumentDeleteData, error])

    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        const newFiles = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: (file.size / (1024 * 1024)).toFixed(2),
            format: file.type.split('/')[1].toUpperCase(),
            file: file,
            previewUrl: URL.createObjectURL(file), // Add this line
            isStaged: true
        }));

        setStagedFiles(prev => [...prev, ...newFiles]);
    };

    // Add removeStagedFile function
    const removeStagedFile = (fileId) => {
        setStagedFiles(prev => {
            const fileToRemove = prev.find(file => file.id === fileId);
            if (fileToRemove?.previewUrl) {
                URL.revokeObjectURL(fileToRemove.previewUrl);
            }
            return prev.filter(file => file.id !== fileId);
        });
    };

    // Add uploadStagedFiles function
    const uploadStagedFiles = () => {
        if (stagedFiles.length === 0) return;

        const data = {
            files: stagedFiles
        };
        onDocumentSubmit(data);
        // setStagedFiles([]); // Clear staged files after upload
    };

    const handleAddComment = () => {
        if (!comment.trim()) return;

        const newComment = {
            text: comment,
        };
        onSubmit(newComment);
    };

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '';

        const date = new Date(timestamp);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSeconds < 60) {
            return 'just now';
        } else if (diffInMinutes < 60) {
            return `${diffInMinutes} ${diffInMinutes === 1 ? 'min' : 'mins'} ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
        } else if (diffInDays < 7) {
            return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
        } else {
            return date.toLocaleDateString();
        }
    };

    const removeFile = (file) => {
        const formData = new FormData();
        formData.append('document_id', file.id);

        dispatch(deleteDocumentsApi(formData));
    }

    const hasAccess = () => {
        const userRole = getUserDetail()?.role;
        const userId = getUserDetail()?.id;
        const isAdminLevel = userRole === 'super-admin' || userRole === 'admin';
        const isTenderLead = userId === uploadModal?.allTenderData?.tender_lead_id;

        if (isAdminLevel || isTenderLead) {
            return true;
        }

        // Check if user is assignee for this document type
        const currentSourceType = getSource(uploadModal?.type);
        const assigneeMatch = uploadModal?.allTenderData?.assignees?.find(
            assignee => assignee.source_type === currentSourceType &&
                assignee.user_id === userId
        );

        return !!assigneeMatch;
    };

    const closeHandler = () => {
        setUploadModal()
        setCancelPopup(false)
        setComment('');
        setStagedFiles([]);
    }

    const cancelModal = <Modal show={cancelPopup} centered className='logout_modal'>
        <Modal.Header>
            <h5>Are you sure ?</h5>
            <MdOutlineClose style={{ cursor: "pointer", fontSize: "22px" }} onClick={() => setCancelPopup(false)} />
        </Modal.Header>
        <Modal.Body>
            <h3>Unsaved changes will be lost, are you sure you want to cancel?</h3>
            <div className='d-flex justify-content-center' style={{ gap: "20px" }}>
                <button className='no_btn'
                    onClick={() => setCancelPopup(false)}>No</button>
                <button type='button' onClick={closeHandler}>
                    Yes
                </button>
            </div>
        </Modal.Body>
    </Modal>

    return (
        <Modal centered className='doc_type' size='lg' show={uploadModal.show}>
            {cancelModal}
            <Modal.Body>
                <div className='add_doc_type'>
                    <div className='head'>
                        <h5>{uploadModal.type}</h5>
                        <MdOutlineClose onClick={stagedFiles?.length > 0 ? () => setCancelPopup(true) : () => {
                            setUploadModal()
                            setComment('');
                            setStagedFiles([]);
                        }} />
                    </div>
                    {!hasAccess() && (
                        <div style={{
                            backgroundColor: '#fff3cd',
                            color: '#856404',
                            padding: '12px',
                            borderRadius: '4px',
                            marginBottom: '15px',
                            fontSize: '14px',
                            textAlign: "center"
                        }}>
                            You only have view access for this document type.
                        </div>
                    )}
                    {getAttachmentLoading ? <Loader /> : (
                        <div className={hasAccess() ? 'document_upload_box' : 'document_upload_box not_access'}>
                            {hasAccess() ? (
                                <>
                                    <div className='upload_box'>
                                        <MdOutlineFileUpload />
                                        <div>
                                            <p>Upload or Drag and Drop your document</p>
                                            <span>Maximum File Size is 20MB</span>
                                            <span>Supported File Types are: .png, .jpg, .pdf, .csv</span>
                                            <input
                                                type="file"
                                                onChange={handleFileUpload}
                                                accept=".png,.jpg,.pdf,.csv"
                                                multiple
                                            />
                                        </div>
                                    </div>

                                    <div className='atatchment_box'>
                                        <h5>Attachments</h5>
                                        <Row style={{ gap: "10px 0" }}>
                                            {stagedFiles.length > 0 && stagedFiles.map((file) => (
                                                <Col md={6} key={file.id}>

                                                    <p>{getUserDetail()?.user_name}</p>
                                                    <div className='attachment_item'>
                                                        <img
                                                            src={closeIcon}
                                                            alt=''
                                                            className='close_icon'
                                                            onClick={() => removeStagedFile(file.id)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <a
                                                            href={file.previewUrl}  // Use previewUrl instead of file directly
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: '10px', alignItems: 'center' }}
                                                        >
                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                            <div>
                                                                <h6>{file.name}</h6>
                                                                <span>File Format: {file.format}</span>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </Col>
                                            ))}
                                            {getAttachmentData?.data?.documents.map((file) => {
                                                const fileURL = file?.media?.split('/')
                                                const fileformat = fileURL[fileURL.length - 1].split('.')
                                                return (
                                                    <Col md={6} key={file.id}>
                                                        <>

                                                            <p>{file?.user?.user_name}</p>
                                                            <div className='attachment_item'>
                                                                {
                                                                    getDocumentDeleteLoading ?
                                                                        <img
                                                                            src={closeIcon}
                                                                            alt=''
                                                                            className='close_icon'
                                                                            style={{ cursor: 'progress' }}
                                                                        /> :
                                                                        <img
                                                                            src={closeIcon}
                                                                            alt=''
                                                                            className='close_icon'
                                                                            onClick={() => removeFile(file)}
                                                                            style={{ zIndex: 2 }}
                                                                        />
                                                                }
                                                                <a
                                                                    href={`${fileBaseUrl}/${file.media}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: '10px', alignItems: 'center' }}
                                                                >
                                                                    <img src={downloadDocImg} alt='' width={'40px'} />
                                                                    <div>
                                                                        <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                        <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    </div>

                                    <div className='comments_box'>
                                        <h6>Comments</h6>

                                        <div className='comment_item'>
                                            <div className='commenter_detail'>
                                                <img src={getUserDetail()?.image ? `${fileBaseUrl}/${getUserDetail()?.image}` : userIcon} alt="" />
                                                <p>{getUserDetail()?.user_name || 'User Name'}</p>
                                            </div>
                                            {hasAccess() && (
                                                <>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            placeholder='Type your reply'
                                                            value={comment}
                                                            onChange={(e) => setComment(e.target.value)}
                                                            onKeyPress={(e) => e.key === 'Enter' && handleAddComment()}
                                                        />
                                                    </div>

                                                    <div className="comment_input_actions">
                                                        <button
                                                            className='comment_btn'
                                                            onClick={handleAddComment}
                                                        >
                                                            {loading ? <Spinner size='sm' /> : 'Comment'}
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {getAttachmentData?.data?.comments?.length > 0 &&
                                            <div className='all_comments_wrapper' style={{ marginTop: "15px" }}>
                                                {
                                                    getAttachmentData?.data?.comments
                                                        ?.slice() // Create a copy of the array to avoid mutating the original
                                                        ?.reverse() // Reverse the copy
                                                        ?.map(c => (
                                                            <div key={c.id} className='comment_item list'>
                                                                <div className='commenter_detail'>
                                                                    <img src={c?.user?.image ? `${fileBaseUrl}/${c?.user?.image}` : userIcon} alt="" />
                                                                    <p>{c?.user?.user_name}</p>
                                                                </div>

                                                                <h6>{c?.comment}</h6>

                                                                <div>
                                                                    <span>{formatTimestamp(c?.created_at)}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                }
                                            </div>
                                        }
                                    </div>

                                    {
                                        stagedFiles.length > 0 &&
                                        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'end', gap: "15px" }}>
                                            <button style={{
                                                backgroundColor: "#fff",
                                                color: "#003A70",
                                                border: "1px solid #003A70",
                                                padding: "5px 25px",
                                                borderRadius: "10px",
                                                fontWeight: "600",
                                                fontSize: "14px",
                                            }}
                                                onClick={() => setCancelPopup(true)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className='comment_btn'
                                                onClick={uploadStagedFiles}
                                                disabled={documentLoading}
                                            >
                                                {documentLoading ? <Spinner size='sm' /> : 'Upload'}
                                            </button>
                                        </div>
                                    }
                                </>
                            ) : (
                                // View-only mode
                                <>
                                    {getAttachmentData?.data?.documents?.length > 0 && (
                                        <div className='atatchment_box'>
                                            <h5>Attachments</h5>

                                            {
                                                documentLoading ? <Loader /> :
                                                    <Row>
                                                        {getAttachmentData?.data?.documents.map((file) => {
                                                            const fileURL = file?.media?.split('/')
                                                            const fileformat = fileURL[fileURL.length - 1].split('.')
                                                            return (
                                                                <Col md={6} key={file.id}>
                                                                    <a
                                                                        href={`${fileBaseUrl}/${file.media}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                                    >
                                                                        <p>{file?.user?.user_name}</p>
                                                                        <div className='attachment_item'>
                                                                            <img src={downloadDocImg} alt='' width={'40px'} />
                                                                            <div>
                                                                                <h6>{fileURL[fileURL.length - 1]}</h6>
                                                                                <span>File Format: {fileformat[fileformat.length - 1]}</span>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                            }
                                        </div>
                                    )}
                                    {
                                        getAttachmentData?.data?.comments?.length > 0 &&
                                        <div className='comments_box'>
                                            <h6>Comments</h6>
                                            <div className='all_comments_wrapper' style={{ marginTop: "15px" }}>
                                                {[...(getAttachmentData?.data?.comments || [])]
                                                    ?.reverse()
                                                    ?.map(c => (
                                                        <div key={c.id} className='comment_item list'>
                                                            <div className='commenter_detail'>
                                                                <img src={c?.user?.image ? `${fileBaseUrl}/${c?.user?.image}` : userIcon} alt="" />
                                                                <p>{c?.user?.user_name}</p>
                                                            </div>

                                                            <h6>{c?.comment}</h6>

                                                            <div>
                                                                <span>{formatTimestamp(c?.created_at)}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    }
                                    {
                                        getAttachmentData?.data?.documents?.length === 0 && getAttachmentData?.data?.comments?.length === 0 && (
                                            <div className='no_data_found'>
                                                <p style={{ textAlign: "center", fontWeight: "600", marginBottom: "0px", marginTop: "30px" }}>No attachments or comments found.</p>
                                            </div>
                                        )
                                    }
                                </>
                            )}
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddAttachment;